export default __webpack_public_path__ + "static/media/pic3.0034011e.jpg";